<div class="nf-wrapper">

  <!-- Background blobs -->
  <div class="nf-blob nf-blob-a"></div>
  <div class="nf-blob nf-blob-b"></div>
  <div class="nf-blob nf-blob-c"></div>

  <!-- Particles -->
  <div class="nf-particle nf-p1"></div>
  <div class="nf-particle nf-p2"></div>
  <div class="nf-particle nf-p3"></div>
  <div class="nf-particle nf-p4"></div>
  <div class="nf-particle nf-p5"></div>

  <!-- Card -->
  <div class="nf-card">

    <!-- 404 Number -->
    <div class="nf-num-wrap">
      <div class="nf-num-glow"></div>
      <div class="nf-num">404</div>
    </div>

    <!-- Illustration -->
    <div class="nf-illo">
      <svg viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="pg" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stop-color="#2d1b4e"/>
            <stop offset="100%" stop-color="#6b1a3a"/>
          </linearGradient>
          <linearGradient id="cg" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#f97316"/>
            <stop offset="100%" stop-color="#fbbf24"/>
          </linearGradient>
          <filter id="sh">
            <feDropShadow dx="0" dy="6" stdDeviation="8" flood-color="#2d1b4e" flood-opacity="0.18"/>
          </filter>
        </defs>
        <rect x="22" y="18" width="66" height="82" rx="10" fill="url(#pg)" filter="url(#sh)"/>
        <rect x="28" y="26" width="54" height="62" rx="6" fill="#f5f3ff"/>
        <rect x="42" y="20" width="26" height="5" rx="2.5" fill="rgba(255,255,255,0.15)"/>
        <text x="55" y="66" text-anchor="middle" font-family="Poppins,sans-serif" font-size="30" font-weight="900" fill="url(#pg)">?</text>
        <circle cx="15" cy="28" r="9" fill="url(#cg)" opacity="0.9"/>
        <text x="15" y="32" text-anchor="middle" font-size="9" font-weight="700" fill="white">₹</text>
        <circle cx="95" cy="40" r="7" fill="url(#cg)" opacity="0.75"/>
        <text x="95" y="44" text-anchor="middle" font-size="8" font-weight="700" fill="white">₹</text>
        <circle cx="88" cy="18" r="5.5" fill="#c084fc" opacity="0.8"/>
        <circle cx="12" cy="68" r="4.5" fill="#ec4899" opacity="0.6"/>
      </svg>
    </div>

    <!-- Text -->
    <h1 class="nf-title">Oops! Page Not Found</h1>
    <p class="nf-subtitle">
      The page you're looking for doesn't exist or has been moved.<br/>
      Let <strong class="nf-brand-name">Nishwik</strong> guide you back to the right place.
    </p>

    <!-- Buttons -->
    <div class="nf-btns d-flex justify-content-center flex-wrap gap-3">
      <a routerLink="/home" class="nf-btn nf-btn-home" routerLink="/">
        <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24">
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
        </svg>
        Go to Home
      </a>
      <a routerLink="/login" class="nf-btn nf-btn-login" routerLink="/login">
        <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24">
          <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"/>
        </svg>
        Go to Login
      </a>
    </div>

  </div>
</div>